"use client";

import { c as _c } from "react/compiler-runtime";
import { ButtonOverride as Button } from "@/components/Buttons/ButtonOverride";
import { DappscoutIframeProvider } from "chewydapp-iframe";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useRouter, useSearchParams } from "next/navigation";
import { ArrowBigLeft, SquareArrowOutUpRight } from "lucide-react";
import ExternalDapp from "@/components/Wallet/ExternalDapp";
import useAppWallet from "@/hooks/useAppWallet";
import useAutoConnectWallet from "@/hooks/useAutoConnectWallet";
import { AnimatePresence, motion } from "motion/react";
import { ButtonGroup, Link } from "@heroui/react";
import type { ChainType } from "@/constants/chain-specific";
const ExternalLinkPage = () => {
  const $ = _c(33);
  const [link, setLink] = useState(null);
  const [currChain, setCurrChain] = useState(109);
  const [ready, setReady] = useState(false);
  const [isChewySwap, setIsChewySwap] = useState(false);
  const router = useRouter();
  const searchParams = useSearchParams();
  let t0;
  if ($[0] !== searchParams) {
    t0 = searchParams.get("to");
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const externalLink = t0;
  const {
    address,
    sendTransaction,
    signMessage,
    signTypedData
  } = useAppWallet(currChain);
  useAutoConnectWallet();
  let t1;
  if ($[2] !== router) {
    t1 = () => {
      router.back();
    };
    $[2] = router;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleBack = t1;
  let t2;
  let t3;
  if ($[4] !== externalLink) {
    t2 = () => {
      if (!externalLink) {
        return;
      }
      setLink(externalLink);
      if (externalLink.toLowerCase().includes("chain=shibarium")) {
        setCurrChain(109);
      }
      if (externalLink.toLowerCase().includes("chain=dogechain")) {
        setCurrChain(2000);
      }
      if (externalLink.toLowerCase().includes("chewyswap.dog")) {
        setIsChewySwap(true);
      }
    };
    t3 = [externalLink];
    $[4] = externalLink;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  useEffect(t2, t3);
  const iframeSrc = link ? decodeURIComponent(link) : "";
  const chainRPC = link && decodeURIComponent(link).includes("dogechain") ? "https://rpc.dogechain.dog" : "https://rpc.shibarium.shib.io";
  let t4;
  if ($[7] !== address || $[8] !== chainRPC || $[9] !== currChain || $[10] !== iframeSrc || $[11] !== isChewySwap || $[12] !== link || $[13] !== sendTransaction || $[14] !== signMessage || $[15] !== signTypedData) {
    t4 = link && isChewySwap ? <DappscoutIframeProvider address={address} appUrl={iframeSrc} rpcUrl={chainRPC} sendTransaction={sendTransaction} signMessage={signMessage} signTypedData={signTypedData}><div><ExternalDapp appUrl={`${link}`} isPending={false} chain={currChain} /></div></DappscoutIframeProvider> : link && <AnimatePresence><motion.iframe layout={true} initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        opacity: {
          ease: "anticipate",
          duration: 2
        },
        layout: {
          ease: "anticipate",
          duration: 1
        }
      }} exit={{
        opacity: 0
      }} src={iframeSrc} className="flex-1 w-full h-[96vh] border-none" title="External Content" onLoad={() => setReady(true)} /></AnimatePresence>;
    $[7] = address;
    $[8] = chainRPC;
    $[9] = currChain;
    $[10] = iframeSrc;
    $[11] = isChewySwap;
    $[12] = link;
    $[13] = sendTransaction;
    $[14] = signMessage;
    $[15] = signTypedData;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[17] !== isChewySwap || $[18] !== ready) {
    t5 = ready || isChewySwap ? null : <div className="flex justify-center align-middle content-center w-full h-svh"><img src="images/spinner.svg" width="150px" height="150px" className="justify-self-center" /></div>;
    $[17] = isChewySwap;
    $[18] = ready;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  let t6;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <ArrowBigLeft width={28} height={28} />;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== handleBack) {
    t7 = <Button isIconOnly={true} variant="shadow" color="secondary" size="md" onPress={handleBack}>{t6}</Button>;
    $[21] = handleBack;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  const t8 = link ?? "";
  let t9;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <SquareArrowOutUpRight width={18} height={18} />;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t8) {
    t10 = <Button as={Link} href={t8} target="_blank" isIconOnly={true} title="Pop Out" variant="shadow" color="secondary" size="md" className="border-l-1 border-black/50">{t9}</Button>;
    $[24] = t8;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== t10 || $[27] !== t7) {
    t11 = <ButtonGroup variant="flat" className="fixed md:bottom-[20px] bottom-[60px] left-[20px] z-[1000]">{t7}{t10}</ButtonGroup>;
    $[26] = t10;
    $[27] = t7;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== t11 || $[30] !== t4 || $[31] !== t5) {
    t12 = <><div className="m-0 p-0 min-h-screen flex flex-col">{t4}{t5}{t11}</div></>;
    $[29] = t11;
    $[30] = t4;
    $[31] = t5;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  return t12;
};
export default ExternalLinkPage;